// A trailing /<n>/, /news/ or /insights/ on a perspectives URL names a
// slice of one archive (IV-1696), not a different page of the site.
export const ARCHIVE_SLICE = /\/(?:news|insights|\d+)\/$/

// /perspectives/, /perspectives/2/ and /perspectives/news/2/ all reduce
// to /perspectives/. Both patterns are anchored on the leading slash so
// they strip whole segments: an unanchored /news\/$/ also matches the
// tail of a post slug, and /perspectives/weekly-news/ and
// /perspectives/weekly-insights/ would then reduce to the same root and
// be mistaken for two slices of one archive.
export function archiveRoot(path) {
    return path
        .replace(/\/\d+\/$/, '/')
        .replace(/\/(?:news|insights)\/$/, '/')
}
